import { pushToDataLayer } from '@helsenorge/framework-utils/adobe-analytics';
export const trackScore = (score) => {
    const testData = {
        event: 'feedback',
        feedback: {
            name: 'brukertilfredshet: score',
            score: score,
            label: score,
        },
    };
    pushToDataLayer(testData);
};
export const trackComment = () => {
    const testData = {
        event: 'feedback',
        feedback: {
            name: 'brukertilfredshet: tilbakemelding',
        },
    };
    pushToDataLayer(testData);
};
